import React, { useCallback, useEffect, useMemo, useContext, useRef, useState } from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import styles from './index.module.scss';

import { Popover } from '@douyinfe/semi-ui';
import cName from 'classnames';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from 'axios';
import MyModal from '@/components/modal';
import { Notification } from '@douyinfe/semi-ui';
import { useSwiper } from 'swiper/react';
import { useRouter } from "next/router";
import { IndexContext } from "@/stores";
//@ts-ignore
import CountUp from 'react-countup';
import Image from 'next/image';
import { PRODDOMAIN } from '@/utils';
import Head from 'next/head';

interface IProps {

}

export const getServerSideProps: GetServerSideProps = async context => {
  const { data } = await axios.get(`${PRODDOMAIN}/api/get_config`);
  
  return {
    props: data.data, // 需要拿props包裹
  };
};

const Home: NextPage<IProps> = (props: any) => {

  const [active, setActive] = useState(0)
  const [data, setData] = useState<any>({})
  const videoRef = useRef()
  const swiperRef = useRef<any>();
  const [isHidden, setIsHidden] = useState(false)
  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  })
  const router = useRouter()
  const [visible, setVisible] = useState(false)

  const transDate = useCallback((date: number): Date => {
    return new Date(String(date).length === 10 ?
      date * 1000 : date
    )
  }, [])

  const getData = useCallback(async () => {
    const { data } = await axios.get(`/axiosapi/index`)
    setData(data?.data)
  }, [])

  const chunkArray = useCallback((arr: any, chunkSize: number) => {
    const chunkedArray = [];
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }, [])

  const handleMouseOver = useCallback(() => {
    setTimeout(() => {
      const dom = document.querySelector('.logo-pop')
      const place = dom?.getAttribute('x-placement');
      document.querySelector('.semi-portal-inner')?.classList.add(`${place}`)
    }, 100)
  }, [])

  useEffect(() => {
    getData()
  }, [])

  return (
    <div className={styles.container}>
      <Head>
        <title>{props?.meta_title_cn}</title>
        <meta name="keywords" content={props?.meta_kws_cn} />
        <meta name="description" content={props?.meta_desc_cn} />
      </Head>
      <main>
        <div className={cName(styles.floatBox, {
          [styles.isHidden]: isHidden
        })}>
          <a href="/exhibition/apply"><img loading='lazy' src="/image/home-float1.png" alt="" /></a>
          <a href="https://cbce2025.gration.cn/?member/register&code=sites" target='_blank'><img loading='lazy' src="/image/home-float2.png" alt="" /></a>
          <div className={styles.btn} onClick={() => setIsHidden(!isHidden)}>
            {/* @ts-ignore */}
            <svg t="1723196878237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672">
              <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#fff">
              </path>
            </svg>
            <span>隐藏</span>
          </div>
        </div>
        <div className={styles.bgBox}>
          <div className={cName([styles.banner, 'banner'])}>
            <Swiper
              className={styles.swiper}
              modules={[Pagination, Autoplay, Navigation]}
              spaceBetween={0}
              autoplay
              slidesPerView={1}
              navigation
              style={{ height: '31vw' }}
            >
              {
                data.banner_kv?.map((item: any) => (
                  <SwiperSlide key={item.id}>
                    <Image loading='lazy' src={item.image} layout='fill' alt="" />
                  </SwiperSlide>
                ))
              }
            </Swiper>
            <div className={styles.bannerNav}>
              <a href="/exhibition/why">
                <img loading='lazy' src="/image/people.png" alt="" />
                <div>
                  <h3>为何参展</h3>
                  <p>海内外知名品牌，亚太一站式精酿平台</p>
                </div>
              </a>
              <a href="visitor/why">
                <img loading='lazy' src="/image/cheers.png" alt="" />
                <div>
                  <h3>为何参观</h3>
                  <p>共同见证精酿啤酒文化的繁荣和成长</p>
                </div>
              </a>
              <a href="https://cbce2025.gration.cn/?exhibitor/login/=" target='_blank'>
                <img loading='lazy' src="/image/team-leader.png" alt="" />
                <div>
                  <h3>展商中心</h3>
                  <p>集聚来自世界各地的专家学者和企业家</p>
                </div>
              </a>

              <div onClick={() => {
                setVisible(true)
              }}>
                <img loading='lazy' src="/image/presentation.png" alt="" />
                <div>
                  <h3>峰会购票</h3>
                  <p>剖析精酿行业的现状与未来，重塑竞争新优势</p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.intro}>
            <div className={styles.left}>
              <h2>CBCE 亚洲国际精酿啤酒会议暨展览会</h2>
              <p><strong>亚洲精酿啤酒会议暨展览会(CBCE)</strong>
                自2016年举办，即将迎来第十周年。在过去的几年中，CBCE经过持续努力和
                积极发展，已成为亚洲规模最大的精酿啤酒专业展览CBCE聚集从酿酒原料、
                装备制造再到终端消费全产业链上下游各环节相关产品，云集海内外知名品
                牌企业，打造亚太地区一站式精酿平台。随着十周年的临近，CBCE也将继
                续致力于推动亚洲精酿啤酒行业的发展，为行业带来更多新的机遇和发展
                趋势，共同见证精酿啤酒文化的繁荣和成长。</p>
              <p>跨界破圈，多维发展，CBCE 2025将再次升级展品范围，新增精酿厨房系统，
                并持续拓展以威士忌、金酒为代表的蒸馏酒领域和硬苏打低度酒等领域。CBCE
                将引领参展企业突破传统界限，迎接行业新趋势，构建多元化的生态优势，为
                精酿啤酒及相关领域的创新发展开辟新路径。</p>
              <a href="/about/survey">
                <div className={cName([styles.more, 'btnStyle'])}>
                  <span>了解更多</span>
                  {/* @ts-ignore */}
                  <svg t="1723196878237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                    <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                    </path>
                  </svg>
                </div>
              </a>
            </div>
            <div className={styles.right}>
              <div className={styles.videoBox}>
                <video src="https://img.cbcechina.com/video/home.mp4"
                  loop
                  muted
                  playsInline
                  controls
                  poster="https://img.cbcechina.com/2024-12-10/ca7c7b2fc08900805c65caebef9d183c.png"></video>
              </div>
            </div>
          </div>
          <div className={styles.introMore}>
            <ul>
              <li>
                <img loading='lazy' src="/image/scalability.png" alt="" />
                <div>
                  <p><CountUp
                    end={20000}
                    duration={1}
                    enableScrollSpy
                  /><span style={{ fontSize: '24px' }}>+</span></p>
                  <span>展览面积</span>
                </div>
              </li>
              <li>
                <img loading='lazy' src="/image/beer-bottle.png" alt="" />
                <div>
                  <p><CountUp
                    end={400}
                    duration={1}
                    enableScrollSpy
                  /><span>家</span></p>
                  <span>参展展商</span>
                </div>
              </li>
              <li>
                <img loading='lazy' src="/image/users.png" alt="" />
                <div>
                  <p><CountUp
                    end={18000}
                    duration={1}
                    enableScrollSpy
                  /><span>人</span></p>
                  <span>专业观众</span>
                </div>
              </li>
              <li>
                <img loading='lazy' src="/image/calendar.png" alt="" />
                <div>
                  <p><CountUp
                    end={10}
                    duration={1}
                    enableScrollSpy
                  /><span style={{ fontSize: '24px' }}>+</span></p>
                  <span>同期活动</span>
                </div>
              </li>
            </ul>

          </div>
          <div className={styles.preBox}>
            <img loading='lazy' src="/image/bubble.png" alt="" />
            <div className={styles.range}>
              <h2>展品范围</h2>
              <img loading='lazy' className={'minHidden'} src="https://img.cbcechina.com/2024-12-10/07897f4e24c0ff8a496ba4131616102c.png" alt="" />
              <div>
                <div>
                  <h2>展品范围</h2>
                  <ul>
                    {data.product_category?.map((item: any) => (
                      <li key={item.text}>
                        <a href={`/about/range?cate=${item.id}`}>
                          <img loading='lazy' src={item.image} alt="" />
                          <span>{item.name_cn}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className={styles.preview}>
              <h2>往届展商</h2>
              <div>
                <Swiper
                  className={styles.swiper}
                  modules={[Autoplay, Pagination]}
                  spaceBetween={0}
                  autoplay
                  pagination={{ clickable: true }}
                  slidesPerView={1}
                >
                  {
                    data.brand_list &&
                    chunkArray(data.brand_list, 24)
                      ?.map((item: any) => (
                        <SwiperSlide>
                          <div className={styles.brandList}>
                            {
                              item.map((child: any) => (
                                <a href={child.link_cn ? child.link_cn : "javascript:;"} target={child.link_cn ? '_blank' : '_self'} key={child.id}>
                                  <img loading='lazy' src={child.image} alt="" />
                                </a>
                              ))
                            }
                          </div>
                        </SwiperSlide>
                      ))
                  }
                </Swiper>

                <p>*以上排名不分先后顺序</p>
              </div>
            </div>
          </div>
          <div className={styles.meeting}>

            <div>
              <h2 className=''>高峰会议</h2>
              <div>
                <p className='middleHidden'>2025国际啤酒酿造峰会由CBCE和EBC(欧洲酿造协会)联合主办，由江南大学生物工程学院和澜埔国际酿酒学院联合协办，以“聚焦酿造革新, </p>
                <p className='middleHidden'>展望精酿新纪元"为主题，2025国际啤酒酿造峰会集聚了来自世界各地共31位的专家学者、企业家，</p>
                <p className='middleHidden'>旨在促进国内啤酒产业的创新、增效及可持续发展。</p>
                <p style={{ display: 'none' }} className='middleShow'>2025国际啤酒酿造峰会由CBCE和EBC(欧洲酿造协会)联合主办，
                  由江南大学生物工程学院和澜埔国际酿酒学院联合协办，以“聚焦
                  酿造革新, 展望精酿新纪元"为主题，2025国际啤酒酿造峰会集
                  聚了来自世界各地共31位的专家学者、企业家， 旨在促进国内啤
                  酒产业的创新、增效及可持续发展。</p>
                <a href="/summit/2025">
                  <div className={cName([styles.more, 'btnStyle'])}>
                    <span>了解会议</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                      </path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className={styles.active}>
            <img loading='lazy' src="/image/bubble.png" alt="" />
            <h2>同期活动</h2>
            <Swiper
              className='active'
              breakpoints={
                {
                  0: {
                    slidesPerView: 1,
                  },
                  840: {
                    slidesPerView: 3,
                  },
                }
              }
              spaceBetween={20}
              autoplay
              modules={[Autoplay, Navigation, Pagination]}
              pagination={{ clickable: true }}
              navigation
            >
              {
                data.events_list?.map((item: any) =>
                (<SwiperSlide key={item.id}>
                  <a href={item.link_cn ? item.link_cn : "javascript:;"} className={styles.activeItem}>
                    <div><img loading='lazy' src={item.image_cn} alt="" /></div>
                    <p>{item.title_cn}</p>
                  </a>
                </SwiperSlide>)
                )
              }
            </Swiper>
          </div>
          <div className={styles.preAudi}>
            <div className={styles.about}>
              <img loading='lazy' className='minHidden' src="/image/home-audience-bg1.png" alt="" />
              <div className='minHidden'>
                <div className={styles.left}>
                  <h2>关于观众</h2>
                  {/* <img loading='lazy' src="/image/about-img1.png" alt="" /> */}
                  <ul className={cName([styles.list])}>
                    <li>
                      <p><CountUp
                        end={30}
                        duration={1}
                        enableScrollSpy
                      /><span>%</span></p>
                      <span>投资与采购</span>
                    </li>
                    <li className={styles.middle}>
                      <p><CountUp
                        end={20}
                        duration={1}
                        enableScrollSpy
                      /><span>%</span></p>
                      <span>搜集市场信息</span>
                    </li>
                    <li>
                      <p><CountUp
                        end={16}
                        duration={1}
                        enableScrollSpy
                      /><span>%</span></p>
                      <span>建立新合作</span>
                    </li>
                    <li>
                      <p><CountUp
                        end={10}
                        duration={1}
                        enableScrollSpy
                      /><span>%</span></p>
                      <span>维持商业关系</span>
                    </li>
                    <li className={styles.middle}>
                      <p><CountUp
                        end={12}
                        duration={1}
                        enableScrollSpy
                      /><span>%</span></p>
                      <span>对新技术和知识获取</span>
                    </li>
                    <li>
                      <p><CountUp
                        end={12}
                        duration={1}
                        enableScrollSpy
                      /><span>%</span></p>
                      <span>经验交流</span>
                    </li>
                  </ul>
                </div>
                <div className={styles.right}>
                  <h3>观众采购决定</h3>
                  {/* <img loading='lazy' src="/image/about-img2.png" alt="" /> */}
                  <ul>
                    <li>
                      <img loading='lazy' src="/image/cup1.png" alt="" />
                      <div>
                        <p><CountUp
                          end={51.14}
                          duration={1}
                          enableScrollSpy
                          decimals={2}
                        /><span>%</span></p>
                        <span>决策者</span>
                      </div>
                    </li>
                    <li>
                      <img loading='lazy' src="/image/cup2.png" alt="" />
                      <div>
                        <p style={{ color: 'white' }}><CountUp
                          end={48.86}
                          duration={1}
                          decimals={2}
                          enableScrollSpy
                        /><span>%</span></p>
                        <span>建议者/影响者</span>
                      </div>
                    </li>
                    <li>
                      <img loading='lazy' src="/image/cup3.png" alt="" />
                      <div>
                        <p style={{ color: '#f18c1b' }}><CountUp
                          end={11.36}
                          duration={1}
                          decimals={2}
                          enableScrollSpy
                        /><span>%</span></p>
                        <span>其他</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <h2 className='minShow' style={{ display: 'none' }}>关于观众</h2>
              <ul className={cName([styles.list, 'minShow'])} style={{ display: 'none' }}>
                <li>
                  <p><CountUp
                    end={30}
                    duration={1}
                    enableScrollSpy
                  /><span>%</span></p>
                  <span>投资与采购</span>
                </li>
                <li className={styles.middle}>
                  <p><CountUp
                    end={20}
                    duration={1}
                    enableScrollSpy
                  /><span>%</span></p>
                  <span>搜集市场信息</span>
                </li>
                <li>
                  <p><CountUp
                    end={16}
                    duration={1}
                    enableScrollSpy
                  /><span>%</span></p>
                  <span>建立新合作</span>
                </li>
                <li>
                  <p><CountUp
                    end={10}
                    duration={1}
                    enableScrollSpy
                  /><span>%</span></p>
                  <span>维持商业关系</span>
                </li>
                <li className={styles.middle}>
                  <p><CountUp
                    end={12}
                    duration={1}
                    enableScrollSpy
                  /><span>%</span></p>
                  <span>对新技术和知识获取</span>
                </li>
                <li>
                  <p><CountUp
                    end={12}
                    duration={1}
                    enableScrollSpy
                  /><span>%</span></p>
                  <span>经验交流</span>
                </li>
              </ul>
              <h3 className='minShow' style={{ display: 'none' }}>观众采购决定</h3>
              <ul className={cName([styles.decide, 'minShow'])} style={{ display: 'none' }}>
                <li>
                  <img loading='lazy' src="/image/cup1.png" alt="" />
                  <div>
                    <p><CountUp
                      end={51.14}
                      duration={1}
                      enableScrollSpy
                      decimals={2}
                    /><span>%</span></p>
                    <span>决策者</span>
                  </div>
                </li>
                <li>
                  <img loading='lazy' src="/image/cup2.png" alt="" />
                  <div>
                    <p style={{ color: 'white' }}><CountUp
                      end={48.86}
                      duration={1}
                      decimals={2}
                      enableScrollSpy
                    /><span>%</span></p>
                    <span>建议者/影响者</span>
                  </div>
                </li>
                <li>
                  <img loading='lazy' src="/image/cup3.png" alt="" />
                  <div>
                    <p style={{ color: '#f18c1b' }}><CountUp
                      end={11.36}
                      duration={1}
                      decimals={2}
                      enableScrollSpy
                    /><span>%</span></p>
                    <span>其他</span>
                  </div>
                </li>
              </ul>
            </div>
            <div className={styles.preview}>
              <h2>部分观众</h2>
              <div>
                <Swiper
                  className={styles.swiper}
                  modules={[Autoplay, Pagination]}
                  spaceBetween={0}
                  autoplay
                  pagination={{ clickable: true }}
                  slidesPerView={1}
                >
                  {
                    data.spectator_list &&
                    chunkArray(data.spectator_list, 24)
                      ?.map((item: any) => (
                        <SwiperSlide>
                          <div className={styles.audiList}>
                            {
                              item.map((child: any) => (
                                <a href={child.link_cn ? child.link_cn : "javascript:;"} target={child.link_cn ? '_blank' : '_self'} key={child.id}>
                                  <img loading='lazy' src={child.image} alt="" />
                                </a>
                              ))
                            }
                          </div>
                        </SwiperSlide>
                      ))
                  }
                </Swiper>
              </div>
              <p>*以上排名不分先后顺序</p>
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.news}>
              <h2>新闻动态</h2>
              <div className={styles.cate}>
                <div className={styles.left}>
                  {
                    data.news_cate?.map((item: any, index: number) => (
                      <div
                        key={item.id}
                        className={cName({
                          [styles.newActive]: active === index
                        })}
                        onClick={() => setActive(index)}
                      >
                        {item.cate_name_cn}
                      </div>
                    ))
                  }
                </div>
                <a href={active !== 2 ? '/media/news' : '/media/industry'}>
                  <div className={cName([styles.more, 'btnStyle'])}>
                    <span>查看更多</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                      </path>
                    </svg>
                  </div>
                </a>
              </div>
              <Swiper
                className='brand'
                slidesPerView={'auto'}
                spaceBetween={26}
                autoplay
                modules={[Autoplay, Pagination]}
                pagination={{ clickable: true }}
              >
                {
                  data.news_cate?.length
                  && data.news_cate[active].new_list.map((item: any) => (
                    <SwiperSlide key={item.id}>
                      <a href={item.info.outlink
                        ? `${item.info.outlink}` :
                        `/media/news/news_detail/${item.id}`}
                        target={item.info.outlink ? "_blank" : ''}>
                        <div className={styles.newItem}>
                          <h3>{item.info.title}</h3>
                          <p>{item.info.brief}</p>
                          <span>{new Date(String(item.publish_time).length === 10 ?
                            item.publish_time * 1000 : item.publish_time
                          ).toLocaleString().replace(/\//g, '-').split(' ')[0]}</span>
                        </div>
                      </a>
                    </SwiperSlide>
                  ))
                }

              </Swiper>
            </div>
            <div className={styles.media}>
              <div>
                <h2>合作媒体</h2>
                <div>
                  <Swiper
                    className={styles.swiper}
                    modules={[Autoplay, Pagination]}
                    spaceBetween={0}
                    autoplay
                    pagination={{ clickable: true }}
                    slidesPerView={1}
                  >
                    {
                      data.medium_list &&
                      chunkArray(data.medium_list, 21)
                        ?.map((item: any) => (
                          <SwiperSlide>
                            <div className={styles.mediaList}>
                              {
                                item.map((child: any) => (
                                  <a href={child.link_cn ? child.link_cn : "javascript:;"} target={child.link_cn ? '_blank' : '_self'} key={child.id}>
                                    <img loading='lazy' src={child.image} alt="" />
                                  </a>
                                ))
                              }
                            </div>
                          </SwiperSlide>
                        ))
                    }
                  </Swiper>

                </div>
                <p>*以上排名不分先后顺序</p>
              </div>
            </div>
            <div className={styles.linkExh}>
              <h2>全球关联展会</h2>
              <Swiper
                className={styles.swiper}
                modules={[Autoplay, Pagination]}
                spaceBetween={0}
                autoplay
                pagination={{ clickable: true }}
                slidesPerView={1}
              >
                {
                  data.relevance_show_list &&
                  chunkArray(data.relevance_show_list, 21)
                    ?.map((item: any) => (
                      <SwiperSlide>
                        <div className={styles.audiList}>
                          {
                            item.map((child: any) => (
                              <a href={child.link_cn ? child.link_cn : "/exhibition/apply"} target={child.link_cn ? '_blank' : '_self'} key={child.id}>
                                {child.brief_cn ? <Popover
                                  arrowStyle={{
                                    backgroundColor: 'black'
                                  }}
                                  style={{
                                    backgroundColor: '#ff9f00',
                                    padding: '30px 60px 20px 50px',
                                    width: '650px',
                                    borderRadius: '80px 120px 120px 40px',
                                    marginBottom: '30px',
                                  }}
                                  className='logo-pop minHidden'
                                  content={
                                    <div>
                                      <p style={{
                                        color: '#6c5421',
                                        lineHeight: '28px'
                                      }}
                                        className='content'
                                        dangerouslySetInnerHTML={{ __html: child.brief_cn }}
                                      />
                                    </div>
                                  }
                                  position="topLeft"
                                  onVisibleChange={() => {
                                    handleMouseOver()
                                  }}
                                >
                                  <div className={styles.logo}>
                                    <img loading='lazy' src={child.image} alt="" />
                                  </div>
                                </Popover>
                                  : <div className={styles.logo}>
                                    <img loading='lazy' src={child.image} alt="" />
                                  </div>}
                                <p>{child.title_cn}</p>
                              </a>
                            ))
                          }
                        </div>
                      </SwiperSlide>
                    ))
                }
              </Swiper>

            </div>
          </div>
        </div>
        <style jsx global lang='scss'>
          {
            `
            .logo-pop::after{
              content:'';
              position:absolute;
              bottom:-70px;
              left:0;
              width:100%;
              height:70px;
              background-image: url(/image/logo-popover-bg.png);
              background-repeat:no-repeat;
              background-position:40px;
              background-size: contain;
            }
            .topRight .logo-pop::after{
              transform: scaleX(-1);
            }
            .bottomLeft{
              transform: scaleY(-1) !important;
            }
            .bottomLeft .logo-pop{
              margin-bottom:60px !important;
            }
            .bottomLeft .content{
              transform: scaleY(-1);
            }
            .bottomRight{
              transform: translateX(-100%) scaleY(-1) !important;
            }
            .bottomRight .logo-pop::after{
              transform: scaleX(-1);
            }
            .bottomRight .content{
              transform: scaleY(-1);
            }
            .bottomRight .logo-pop{
              margin-bottom:60px !important;
            }
              .banner .swiper-button-prev{
                left:40px;
              }
              .banner .swiper-button-next{
                right:40px;
              }
              .active .swiper-button-prev{
                left:-60px;
              }
              .active .swiper-button-next{
                right:-60px;
              }
              .active{
                overflow: visible;
                max-width:1640px;
              }
              .active .swiper-slide{
                opacity: 1;
              }
              .active .swiper-slide-next + div + div,
              .active .swiper-slide-prev{
                opacity: 0;
              }
              .banner .swiper-button-prev,
              .banner .swiper-button-next{
                background-color: #FCB814;
                height: 80px;
                width: 40px;
              }
              .active .swiper-button-prev,
              .active .swiper-button-next{
                background-color: #FCB814;
                height: 40px;
                width: 40px;
                border-radius:50%;
              }
              .banner .swiper-button-prev::after,
              .banner .swiper-button-next::after{
                color: white;
                transform: scale(0.5);
              }
              .active .swiper-button-prev::after,
              .active .swiper-button-next::after{
                color: #333;
                transform: scale(0.4);
                font-weight:600;
              }
              .banner .swiper-slide img{
                width:100%;
                object-fit: cover;
                height: 31vw;
              }
              .brand .swiper-slide,
              .active .swiper-slide{
                width:auto;
              }
              .swiper-pagination{
                bottom: 0 !important;
              }
              .swiper-pagination-bullet{
                width: 40px;
                height: 6px;
                border-radius: 2px;
                background-color: #e3e3e3;
              }
              .brand .swiper-pagination-bullet{
                background-color: #393637;
              }
              .swiper-pagination-bullet{
                background-color: #393637;
              }
              .swiper-pagination-bullet-active{
                background-color:#F6A800 !important;
              }
              @media screen and (max-width: 800px) {
                .banner .swiper-button-prev,
                .banner .swiper-button-next{
                  display:none !important;
                }
                .active .swiper-button-prev,
                .active .swiper-button-next{
                  display:none !important;
                }
                .brand .swiper-slide,
                .active .swiper-slide{
                  width:100%;
                }
              }
            `
          }
        </style>
      </main>
      <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal>
    </div>
  );
};

export default Home;
